import { render, staticRenderFns } from "./LinkNotFound.vue?vue&type=template&id=fc9f171a&scoped=true"
import script from "./LinkNotFound.vue?vue&type=script&lang=js"
export * from "./LinkNotFound.vue?vue&type=script&lang=js"
import style0 from "./LinkNotFound.vue?vue&type=style&index=0&id=fc9f171a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9f171a",
  null
  
)

export default component.exports